import { Accordion, styled } from "@mui/material";

const AccessAccordion = styled(Accordion, { shouldForwardProp: (prop) => prop !== "isChildrenHovered" })<{
  isChildrenHovered: boolean;
}>(({ theme, isChildrenHovered }) => ({
  width: "100%",
  borderRadius: 8,
  backgroundColor: "transparent",
  border: "1px solid",
  borderColor: theme.palette.backgroundAlpha.border,
  ...(!isChildrenHovered && {
    "&:hover": {
      background: theme.palette.backgroundAlpha.hover,
      transition: theme.transitions.create(["background"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  }),
}));

export default AccessAccordion;
